var _defs, _polyline, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC4WwwIconsWhiteIntercomAnywhere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line_Work",
    "data-name": "Line Work",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C4_WWW_Icons_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.55 67.95 35.55 79.1 64.45 79.1 64.45 67.88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.28,57.13a52.17,52.17,0,0,0,5-2.27l0-3.92s-1.52-1.2-2-4.86c-1,.27-.91-1.11-1-2a.54.54,0,0,1,.21-.58l.12-1.36s-.48-8.49,7.18-8.49c8.54,0,7.16,8.49,7.16,8.49l.13,1.36a.54.54,0,0,1,.21.58c0,.89,0,2.27-1,2-.49,3.66-2,4.81-2,4.81l0,3.88s1,.53,5,2.23a23,23,0,0,0,4.36,1.32,4.75,4.75,0,0,1,.56.25V24.79H35.55V58.53a4.31,4.31,0,0,1,.6-.22A14.87,14.87,0,0,0,40.28,57.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.45,67.88V58.57a4.75,4.75,0,0,0-.56-.25A23,23,0,0,1,59.53,57c-4.06-1.7-5-2.23-5-2.23l0-3.88s1.51-1.15,2-4.81c.94.27.92-1.11,1-2a.54.54,0,0,0-.21-.58l-.13-1.36s1.38-8.49-7.16-8.49c-7.66,0-7.18,8.49-7.18,8.49l-.12,1.36a.54.54,0,0,0-.21.58c0,.89,0,2.27,1,2,.49,3.66,2,4.86,2,4.86l0,3.92a52.17,52.17,0,0,1-5,2.27,14.87,14.87,0,0,1-4.13,1.18,4.31,4.31,0,0,0-.6.22V68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.44,21.83a.47.47,0,0,0,0,.93h4.93a.47.47,0,0,0,0-.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.77,34.64m0-6.37M33.27,79.33a2.24,2.24,0,0,0,2.24,2.24H64.27a2.24,2.24,0,0,0,2.24-2.24V22.2A2.24,2.24,0,0,0,64.27,20H35.51a2.24,2.24,0,0,0-2.24,2.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.73,21.83a.47.47,0,1,0,.47.47A.47.47,0,0,0,53.73,21.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4WwwIconsWhiteIntercomAnywhere);
export default __webpack_public_path__ + "static/media/C4_WWW_Icons_White-Intercom-Anywhere.1ac4e6fbb1297b6c9998d2f1d2211a5f.svg";
export { ForwardRef as ReactComponent };